export enum ActivityStreamlineAction {
  Create = 'CREATE',
  Update = 'UPDATE',
  Delete = 'DELETE',
  CallExternalService = 'CALL_EXTERNAL_SERVICE',
}
